import axios from "axios";

const instance = axios.create({
  baseURL: "https://hrm-fake.cwr.i24h.app",
  headers: { "Content-Type": "application/json", Authorization: "abc12345" },
});

export default instance;
